import { readingSlice } from "@app/routes/activities/reading/store/readingSlice";
import { spellingSlice } from "@app/routes/activities/spelling/store/spellingSlice";

import { handleReadingAction } from "./readingActions";
import { handleSpellingBeforeAction, handleSpellingAfterAction } from "./spellingActions";


const measurementsMW = () => store => next => action => {
  const stateBefore = store.getState();
  
  action.type.startsWith(spellingSlice.name) && handleSpellingBeforeAction(store, stateBefore, action);
  
  const result = next(action);
  const stateAfter = store.getState();
  
  action.type.startsWith(readingSlice.name) && handleReadingAction(store, stateAfter, action);
  action.type.startsWith(spellingSlice.name) && handleSpellingAfterAction(store, stateAfter, action);

  return result;
};
  
export default measurementsMW();
